<form [formGroup]="aboutFg" #form="ngForm">
  <section>
    <div class="group-section title-section">
      <h1 class="mat-headline-large">About your personal loan</h1>
      <p class="mat-body-large">Please tell us what you'd like to use the loan for and how much you'd like to borrow.</p>
    </div>

    <ng-container *ngFor="let purposeGroup of aboutFg.controls.loanPurposes.controls; let index = index">
      <div class="group-section small-group">
        <div class="flex-content height-24">
          <p class="mat-body-large">Loan purpose {{ index + 1 }}</p>
          <button *ngIf="index > 0" mat-button class="link-button no-background-link remove" type="button"
            (click)="removeLoanPurpose(index)">
            <mat-icon svgIcon="trash"></mat-icon>Remove
          </button>
        </div>
        <app-form-field-select label="Type" [control]="purposeGroup.controls.purpose" [options]="loanPurposeOptions"
          [formSubmitted]="form.submitted">
        </app-form-field-select>
        <app-form-field *ngIf="isOtherLoanPurpose(index)" label="Other information"
          [control]="aboutFg.controls.loanPurposeOther" [formSubmitted]="form.submitted">
        </app-form-field>
        <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
          [control]="purposeGroup.controls.amount" [decimal_precision]="2">
        </app-form-field-currency>
      </div>
    </ng-container>

    <mat-error *ngIf="aboutFg.controls.loanPurposes.hasError('duplicateLoanPurpose')">
      Please select a different loan purpose, each can only be selected once.
    </mat-error>

    <div *ngIf="aboutFg.controls.loanPurposes.length < 3" class="height-24">
      <button mat-button class="link-button no-background-link" type="button" (click)="addLoanPurpose()">
        <mat-icon svgIcon="add"></mat-icon>Add loan purpose
      </button>
    </div>
  </section>

  <hr class="separator" />

  <section>
    <div class="group-section title-section">
      <h1 class="mat-headline-large">Loan details</h1>
    </div>

    <div class="group-section small-group">
      <p class="mat-body-large">What is your preferred loan term (in months)?</p>
      <div class="group-required">
        <mat-button-toggle-group class="button-group" aria-label="What is your preferred loan term (in months)?"
          [formControl]="aboutFg.controls.preferredLoanTerm" [hideSingleSelectionIndicator]="true">
          <mat-button-toggle [value]="12">12</mat-button-toggle>
          <mat-button-toggle [value]="24">24</mat-button-toggle>
          <mat-button-toggle [value]="36">36</mat-button-toggle>
          <mat-button-toggle [value]="48">48</mat-button-toggle>
          <mat-button-toggle [value]="60">60</mat-button-toggle>
          <mat-button-toggle [value]="72">72</mat-button-toggle>
        </mat-button-toggle-group>
        <mat-error *ngIf="form.submitted && aboutFg.controls.preferredLoanTerm.hasError('required')">
          Please select a loan term.
        </mat-error>
      </div>
    </div>

    <div class="group-section small-group">
      <p class="mat-body-large section-title">
        How often would you like to make your loan repayments?
        <span class="mat-body-large section-subtitle">This usually aligns with your primary income payment frequency.</span>
      </p>
      <div class="group-required">
        <mat-button-toggle-group class="button-group" aria-label="How often would you like to make your loan repayments?"
          [formControl]="aboutFg.controls.repaymentFrequency" [hideSingleSelectionIndicator]="true">
          <mat-button-toggle [value]="LoanInformationBaseRequestPeriodTypeEnum.Weekly">Weekly</mat-button-toggle>
          <mat-button-toggle [value]="LoanInformationBaseRequestPeriodTypeEnum.Fortnightly">Fortnightly</mat-button-toggle>
          <mat-button-toggle [value]="LoanInformationBaseRequestPeriodTypeEnum.Monthly">Monthly</mat-button-toggle>
        </mat-button-toggle-group>
        <mat-error *ngIf="form.submitted && aboutFg.controls.repaymentFrequency.hasError('required')">
          Please select how often you'd like to make repayments.
        </mat-error>
      </div>
    </div>

    <div class="group-section info-box">
      <div class="flex-content" *ngFor="let purposeGroup of aboutFg.controls.loanPurposes.controls">
        <span class="mat-body-large">{{ loanPurposeLabel(purposeGroup.controls.purpose.value) }}</span>
        <span class="mat-body-large">{{ purposeGroup.controls.amount.value ?? 0 | currency }}</span>
      </div>
      <hr class="separator no-margin" />
      <div class="flex-content">
        <span class="mat-title-medium black-font">Total requested amount</span>
        <span class="mat-headline-large">{{ totalRequestedAmount() | currency }}</span>
      </div>
    </div>

    <div class="group-section">
      <mat-slide-toggle [formControl]="aboutFg.controls.includeMaxBorrowAmount" hideIcon>
        I would also like to know the maximum amount I can borrow.
      </mat-slide-toggle>
    </div>

    <div class="section-next">
      <button class="btn-next" mat-flat-button (click)="onButtonNext(aboutFg, parentStepper)">Next</button>
    </div>
  </section>
</form>
